import cx from 'classnames'
import Icon from 'components/Icon'
import { FormGroupContainer, FormRow } from 'components/inputs'
import {
  CustomSelect,
  formatMemberOption,
  RenderSearchItemProps,
  useCustomSelectStateFromItemSource,
} from 'components/inputs/CustomSelect'
import SearchResultItem from 'components/inputs/CustomSelect/SearchResultItem'
import { observer } from 'mobx-react'
import React from 'react'
import styles from './TransferClientDialog.sass'
import Member from 'iam/models/Member'
import Avatar, { Badge } from 'components/Avatar'
import { truncate } from 'lodash'
import ClientInputEditorViewModel from './ClientInputEditorViewModel'

interface ClientInputEditorProps {
  vm: ClientInputEditorViewModel
}

export default observer(function ClientInputEditor({
  vm,
}: ClientInputEditorProps) {
  const selectClientProps = useCustomSelectStateFromItemSource({
    itemSource: vm.fetchClients,
    debounce: 250,
  })
  return (
    <>
      <FormRow>
        <FormGroupContainer model={vm} field="currentClient">
          <div className={styles.memberInfo}>
            <div className={styles.avatarContainer}>
              <Avatar
                badge={
                  vm.currentClient.user.online ? Badge.Online : Badge.Offline
                }
                size={40}
                subject={{
                  avatar: vm.currentClient.avatar,
                  displayName: vm.currentClient.displayName,
                }}
              />
            </div>
            <div className={styles.memberContent}>
              <strong className={styles.memberTitle}>
                {vm.currentClient.displayName}
              </strong>
              <p className={styles.memberSubtitle}>Current Client</p>
            </div>
          </div>
        </FormGroupContainer>
      </FormRow>
      <FormRow className={styles.row}>
        <FormGroupContainer
          model={vm}
          field="client"
          className={styles.selectClientContainer}
          error={vm.validationClient.getError('client')}
        >
          <div className={styles.newClientLabel}>New Client</div>
          <CustomSelect
            {...selectClientProps}
            multi={false}
            icon={<Icon name="dropdown" className={cx(styles.icon)} />}
            itemToString={(i) =>
              truncate(formatMemberOption(i), { length: 60 })
            }
            placeholder="Select new client"
            value={vm.client}
            onChange={vm.setClient}
            renderSearchItem={(props) => (
              <TransferToClientSearchItem {...props} />
            )}
            data-test="transfer-to-client-dropdown"
          />
        </FormGroupContainer>
        <div className={styles.warning}>
          Make sure that the Client and/or Team you are transferring to has a
          valid billing method!
        </div>
      </FormRow>
    </>
  )
})

interface TransferToClientSearchItem extends RenderSearchItemProps<Member> {}

const TransferToClientSearchItem = React.forwardRef(
  (
    { item, itemToString, ...itemProps }: TransferToClientSearchItem,
    ref: React.Ref<any>
  ) => {
    return (
      <SearchResultItem
        className={cx(styles.searchResultItem)}
        ref={ref}
        {...itemProps}
        data-test={
          'transfer-to-client-option-' + item.user.publicId?.toLowerCase()
        }
      >
        {formatMemberOption(item)}
      </SearchResultItem>
    )
  }
)
